import React, { Suspense, ReactNode } from 'react';
import { PageLoader } from '../ui';
import PageTransition from './PageTransition';

interface LazyRouteProps {
  children: ReactNode;
  message?: string;
}

/**
 * LazyRoute component for wrapping lazy-loaded routes with Suspense
 * This creates a consistent loading experience across the application
 * Now with animated page transitions using the PageTransition component
 */
export const LazyRoute: React.FC<LazyRouteProps> = ({ 
  children, 
  message = "Sayfa yükleniyor..." 
}) => {
  return (
    <Suspense fallback={<PageLoader fullScreen message={message} />}>
      <PageTransition>
        {children}
      </PageTransition>
    </Suspense>
  );
};

export default LazyRoute; 